<template>
  <o-section :title="label || schema.verbose_name" not-closable :level="level">
    <o-repeating-cards
      :list="items"
      @change="changed"
      :default-new-value="newChild"
      disable-move
      :disable-add="disableAdd"
      :form-state="formState"
      :item-name="schema.verbose_name"
      :disable-delete="disableDelete"
      :disabled="isLocked"
    >
      <template slot-scope="props">
        <item-form
          :item="items[props.index]"
          :items="items"
          :server-errors="_se[props.index]"
          :form-state="formState"
          :level="level"
          :notificationShown="notificationShown"
          :blockedStartDate="blockedStartDate"
          :blockedEndDate="blockedEndDate"
          :index="props.index"
          @changedDates="evaluateDates($event)"
          @start_date_less_than_3_days="notifyLessThanThreeDays($event)"
          :employee-id="employeeId"
        ></item-form>
      </template>
    </o-repeating-cards>
  </o-section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";

import OSection from "../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../vue-ocom/components/table/ORepeatingCards";

import ItemForm from "./ItemForm";
import moment from "moment";

export default {
  name: "LeaveRequestTypeFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("LeaveRequestType"),
    CreateCodeTableFetchMixin(["CodeLeaveType"]),
  ],
  components: { OSection, ORepeatingCards, ItemForm },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
    isLocked: { type: Boolean, default: false },
    employeeId: {},
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.LeaveRequestType,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.LeaveRequestType),

      notificationShown: false,
      blockedStartDate: null,
      blockedEndDate: null,
    };
  },
  methods: {
    ...mapMutations(["showMessage"]),
    adjustDates() {
      for (let i = 0; i < this.items.length; i++) {
        if (i >= 1) {
          // this.items[i]["start_date"] = this.items[i-1]["end_date"] + 1 day
          // if this.items[i]["end_date"] < this.items[i]["start_date"] then
          //    this.items[i]["end_date"] = null

          this.items[i]["start_date"] = moment(
            this.items[i - 1]["end_date"],
            "YYYY-MM-DD"
          )
            .add(1, "days")
            .format("YYYY-MM-DD")
            .toString();
          // if (this.items[i]["end_date"] < this.items[i]["start_date"])
            // this.items[i]["end_date"] = null;
        }
      }
    },
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
    evaluateDates(dates) {
      var start_date = dates["start_date"];
      var end_date = dates["end_date"];

      this.adjustDates();

      var vm = this;
      var list_options = {
        limit: 10000,
        offset: 0,
        filter: "for_block_out_dates",
        params: {
          start_date: start_date,
          end_date: end_date,
        },
      };

      this.notificationShown = false;

      if (start_date !== null && end_date !== null) {
        this.$store
          .dispatch("BlockOutDateModule/getAll", list_options)
          .then((response) => {
            if (response.total_items > 0 && !vm.notificationShown) {
              vm.notificationShown = true;
              vm.blockedStartDate = moment(response["items"][0]["start_date"])
                .format("DD/MM/YYYY")
                .toString();
              vm.blockedEndDate = moment(response["items"][0]["end_date"])
                .format("DD/MM/YYYY")
                .toString();
            }
          })
          .catch((error) => {
            vm.showMessage({
              message: "An error occured",
              type: "danger",
              show: true,
            });
          });
      }
    },
    notifyLessThanThreeDays(isLessThanThreeDays) {
      // Notify the parent component that the start_date is less than 3 days
      this.$emit("start_date_less_than_3_days", isLessThanThreeDays);
    },
  },
  computed: {
    disableAdd() {
      if (this.items) {
        if (this.items[this.items.length - 1].part_of_day > 1) {
          //partial day
          return true; // Can't add days after
        }
      }
      return false;
    },
    disableDelete() {
      if (this.items) {
        return this.items.length <= 1;
      }
      return false;
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
